import { render, staticRenderFns } from "./eindhoven.vue?vue&type=template&id=045ea8d6"
import script from "./eindhoven.vue?vue&type=script&lang=js"
export * from "./eindhoven.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports